const helpers = {
	spacer: (multiplier = 1): number => 8 * multiplier,
};

export default helpers;
